import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CommonConstants,
  EndpointKeys
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  CustomError,
  handleError,
  HttpRequestMethods,
  logCustomError
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { IDP_APPS } from '../models/app.constants';
import { AEMEducationalContent } from '../models/educational-content-aem.interfaces';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  errorHandler = handleError.bind(this);

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getEducationalContent = (): Observable<AEMEducationalContent> =>
    new ApiBuilder<undefined, AEMEducationalContent>(this.http, this.appConfig)
      .app(IDP_APPS)
      .endpointKey(EndpointKeys['SKYMILES_AEM_EDUCATIONAL_CONTENT'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(IDP_APPS)
      .create()
      .pipe(
        map((response: AEMEducationalContent | CustomError) => {
          return this.existCustomError(response);
        })
      );

  existCustomError(
    response: AEMEducationalContent | CustomError
  ): AEMEducationalContent {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS,
        IDP_APPS,
        EndpointKeys.SKYMILES_AEM_EDUCATIONAL_CONTENT
      );
      throw throwError(response);
    }
    return response;
  }
}
